import React from 'react';
import { motion } from 'framer-motion';
import { Scale } from 'lucide-react';
export const Navbar = () => {
  return <div className="fixed top-3 md:top-5 inset-x-0 z-50 flex justify-center px-4 pointer-events-none" data-id="element-182">
      <motion.nav initial={{
      opacity: 0,
      y: -16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="pointer-events-auto w-full max-w-3xl flex items-center justify-between gap-4 rounded-full border border-legal-700 bg-legal-800/80 backdrop-blur-md px-4 sm:px-6 py-2.5 shadow-[0_8px_30px_rgba(0,0,0,0.4)]" data-id="element-183">
        <a href="#" className="flex items-center gap-2 group" aria-label="Conversion Elite — inicio" data-id="element-184">
          <span className="flex items-center justify-center w-8 h-8 rounded-full bg-gold-500/10 border border-gold-500/30 text-gold-500" data-id="element-185">
            <Scale className="w-4 h-4" data-id="element-186" />
          </span>
          <span className="font-serif font-bold tracking-wide text-white text-sm sm:text-base leading-none" data-id="element-187">
            CONVERSION <span className="text-gold-500" data-id="element-188">ELITE</span>
          </span>
        </a>

        <motion.a href="#oferta" whileHover={{
        scale: 1.04
      }} whileTap={{
        scale: 0.96
      }} className="shrink-0 rounded-full bg-gold-500 hover:bg-gold-400 text-legal-900 font-bold text-xs sm:text-sm px-4 sm:px-5 py-2 transition-colors" data-id="element-189">
          Quiero el tratado
        </motion.a>
      </motion.nav>
    </div>;
};